import { Grid } from "@mui/material";
import { useCallback } from "react";
import type { MetricCellValueUpdate, MetricExtensionsService } from "../../../api/dataCollectionTypes";
import type { DataSubmissionLayout, ResolvedBlockContent } from "../../../api/inputFormTypes";
import ScrollableFlexContainer from "../../ScrollableFlexContainer";
import DataSubmissionFormBlock from "./DataSubmissionFormBlock";
import { DataSubmissionFormContextProvider } from "./DataSubmissionFormContext";

interface Props {
  recipientObjectId: string;
  layout: DataSubmissionLayout;
  blockContents: ResolvedBlockContent[];
  isSubmissionEditable: boolean;
  metricExtensionsService: MetricExtensionsService;
  onBlockCellValuesEdit: (blockId: string, cellValueUpdates: MetricCellValueUpdate[]) => void;
}

const DataSubmissionForm = ({
  recipientObjectId,
  layout,
  blockContents,
  isSubmissionEditable,
  metricExtensionsService,
  onBlockCellValuesEdit,
}: Props) => {
  const getBlockContent = useCallback(
    (blockId: string) => blockContents.find((blockContent) => blockContent.blockId === blockId)?.content,
    [blockContents]
  );

  return (
    <DataSubmissionFormContextProvider
      recipientObjectId={recipientObjectId}
      isSubmissionEditable={isSubmissionEditable}
      getBlockContent={getBlockContent}
      metricExtensionsService={metricExtensionsService}
      onBlockCellValuesEdit={onBlockCellValuesEdit}
    >
      <ScrollableFlexContainer>
        <Grid container sx={{ flex: 1, py: 2.5, px: 3 }} spacing={1}>
          {layout.blocks.map((block) => (
            <DataSubmissionFormBlock key={block.id} block={block} />
          ))}
        </Grid>
      </ScrollableFlexContainer>
    </DataSubmissionFormContextProvider>
  );
};

export default DataSubmissionForm;
